module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/february-30972da75d9c1e1f4aae814a10d6608d.png";